export default __webpack_public_path__ + "static/media/CNo.78-6.ba152a76.jpg";